import { Row } from '@tanstack/react-table';
import { NewNumericFilterValue, NumericFilterValue } from '@components/primitives/dataGrid/components/filters/NumericFilter';

const numericFilter = <TData extends object>(row: Row<TData>, columnId: string, value: NewNumericFilterValue) => {
    const rowValue = row.getValue(columnId) as number;
    let columnFilterValue = value as NewNumericFilterValue;

    // @ts-expect-error Migrate old filter values to new format
    if (columnFilterValue?.length) {
        const oldColumnFilterValue = value as NumericFilterValue;

        if (oldColumnFilterValue) {
            columnFilterValue = {
                min: Number(oldColumnFilterValue[0]),
                max: Number(oldColumnFilterValue[1]),
                isRangeMode: oldColumnFilterValue[0] !== oldColumnFilterValue[1],
            };
        }
    }

    const { min, max } = columnFilterValue ?? {};

    // Only min filled
    if (min && !max) {
        if (!rowValue) {
            return false;
        }

        return rowValue >= +min;
    }
    // Only max filled
    if (!min && max) {
        if (!rowValue) {
            return false;
        }

        return rowValue <= +max;
    }

    // Both values filled
    if (min && max) {
        if (min === max) {
            if (!rowValue) {
                return false;
            }
            // Search for exact value
            return rowValue.toFixed(2).indexOf(min.toString()) !== -1;
        }

        if (!rowValue) {
            return false;
        }

        return rowValue >= +min && rowValue <= +max;
    }

    return true;
};

export default numericFilter;
